/*
 *
 * ReportHeaderV2 constants
 *
 */

export const GET_MEDITIONS_WATCHER =
  "app/Report/ReportHeaderV2/GET_MEDITIONS_WATCHER"
export const GET_MEDITIONS_SUCCESS =
  "app/Report/ReportHeaderV2/GET_MEDITIONS_SUCCESS"
export const GET_MEDITIONS_FAILED =
  "app/Report/ReportHeaderV2/GET_MEDITIONS_FAILED"

export const SET_CURRENT_MEDITION =
  "app/Report/ReportHeaderV2/SET_CURRENT_MEDITION"

export const OFFICIALIZE_MEDITIONS_WATCHER =
  "app/Report/ReportHeaderV2/OFFICIALIZEMEDITIONS_WATCHER"
export const OFFICIALIZE_MEDITIONS_SUCCESS =
  "app/Report/ReportHeaderV2/OFFICIALIZE_MEDITIONS_SUCCESS"
export const OFFICIALIZE_MEDITIONS_FAILED =
  "app/Report/ReportHeaderV2/OFFICIALIZE_MEDITIONS_FAILED"

export const MEDITIONS_ACTIONS_WATCHER =
  "app/Report/ReportHeaderV2/MEDITIONS_ACTIONS_WATCHER"
export const MEDITIONS_ACTIONS_SUCCESS =
  "app/Report/ReportHeaderV2/MEDITIONS_ACTIONS_SUCCESS"
export const MEDITIONS_ACTIONS_FAILED =
  "app/Report/ReportHeaderV2/MEDITIONS_ACTIONS_FAILED"

export const GET_SURVEY_TYPES_WATCHER =
  "app/Report/ReportHeaderV2/GET_SURVEY_TYPES_WATCHER"
export const GET_SURVEY_TYPES_SUCCESS =
  "app/Report/ReportHeaderV2/GET_SURVEY_TYPES_SUCCESS"
export const GET_SURVEY_TYPES_FAILED =
  "app/Report/ReportHeaderV2/GET_SURVEY_TYPES_FAILED"


export const GET_MEASURE_WATCHER = "app/Report/ReportHeaderV2/GET_MEASURE_WATCHER"
export const GET_MEASURE_SUCCESS = "app/Report/ReportHeaderV2/GET_MEASURE_SUCCESS"
export const GET_MEASURE_FAILED = "app/Report/ReportHeaderV2/GET_MEASURE_FAILED"